module.exports = __webpack_public_path__ + "static/img/6.6c3f0c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/zh/6.png
// module id = U8MB
// module chunks = 0